import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { ArrowUpRight } from "lucide-react";

const LINKS = [
  { name: "Brunnenandi", desc: "Der preiswerte Online-Shop für alle Brunnen-Selbstbauer", url: "http://www.brunnenandi.de/" },
  { name: "Bormann's Pankower Chroniken", desc: "Geschichte und Geschichten aus Pankow und Rosenthal", url: "http://www.pankowerchronikel.de/" },
  { name: "Fred Krumnow Flüssiggasbetrieb", desc: "Gasservice für die Anlage", url: "https://www.google.de/search?q=Gasservice+fred+krumnow" },
  { name: "Berliner Wasserbetriebe", desc: "Informationen zu Abwasser und Gebühren", url: "https://www.bwb.de/de/gebuehren.php" },
  { name: "Berliner Feuerwehr", desc: "Offizielle Website der Berliner Feuerwehr", url: "https://www.berliner-feuerwehr.de/" },
  { name: "Polizei Berlin", desc: "Offizielle Website der Polizei Berlin", url: "https://www.berlin.de/polizei" },
  { name: "KV Berlin – Notfallrufnummern", desc: "Kassenärztliche Vereinigung Berlin", url: "https://www.kvberlin.de/notfallrufnummern/" },
  { name: "KVA Berlin Mitte-Nord", desc: "Kirchliches Verwaltungsamt – Verwaltung der Anlage", url: "http://www.kva-bmn.de/kirchliches-verwaltungsamt-berlin-mitte-nord" },
];

export default function Links() {
  return (
    <section id="links" className="py-16 md:py-28" data-testid="links-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="08"
          eyebrow="Links"
          title="Nützliches rund um den Garten"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {LINKS.map((l, i) => (
            <Reveal key={l.name} delay={(i % 2) * 0.07}>
              <a
                href={l.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`external-link-${i}`}
                className="group flex items-center justify-between gap-4 rounded-2xl border border-[#D8D3C5] bg-white px-6 py-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-[#5A826B]"
              >
                <div>
                  <p className="font-display text-lg font-semibold text-[#1A382B] transition-colors group-hover:text-[#C85A32]">{l.name}</p>
                  <p className="mt-0.5 text-sm text-[#47544A]">{l.desc}</p>
                </div>
                <ArrowUpRight size={18} className="shrink-0 text-[#6F7E73] transition-all duration-300 group-hover:text-[#C85A32] group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
